import Axios from "axios";

const state = {
  widget_titles: [],
}

const getters = {
  widgetTitles (state) {
    let titles = state.widget_titles.map ( widget_title => {
     return  {label: widget_title.attributes.title, value: widget_title.attributes.title }
    })
    return  titles
  }
}

const mutations = {
  setWidgetTitles (state, widget_titles) {
    state.widget_titles = widget_titles
  }
}

const actions = {
  async getWidgetTitles({ commit }) {
    try {
      const payload = await Axios.get('widget_titles')
      commit('setWidgetTitles', payload.data.data)
    }
    catch (e) {
      return console.log(e)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
